module.exports = __webpack_public_path__ + "img/交易记录.69d51fc3.png";